export enum AtomChartLinePeriodEnum {
  DAY = "day",
  WEEK = "week",
  MONTH = "month",
}
